import React, { useState } from "react";
import { useUserStyles } from "../hooks/useUserStyles";
import { MenuItem, Menu, Button, Stack, Typography } from "@mui/material";
import { UserStyleModel } from "../models/StylesModels";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import AddIcon from "@mui/icons-material/Add";
import { Link } from "react-router-dom";
import { environment } from "../config/environment";
import Star from "../assets/icons/Star";
import Pen from "../assets/icons/Pen";

const UserStyles: React.FC<{ handleStyleChange: (style: UserStyleModel) => void }> = ({ handleStyleChange }) => {
  const { styles } = useUserStyles();
  const [selectedStyle, setSelectedStyle] = useState<UserStyleModel | null>(null);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectStyle = (style: UserStyleModel) => {
    setSelectedStyle(style);
    setAnchorEl(null);
    handleStyleChange(style);
  };

  React.useEffect(() => {
    if (styles && styles.length > 0) {
      setSelectedStyle(styles.find((style) => style.isDefault) ?? styles[0]);
    }
  }, [styles]);

  return (
    <>
      <Button size="small" onClick={handleClick} variant="text" color="inherit" startIcon={<Pen />}>
        {selectedStyle
          ? selectedStyle.name.length > 15
            ? selectedStyle.name.slice(0, 15) + "..."
            : selectedStyle.name
          : "Select style"}
      </Button>
      <Menu
        id="user-tone-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "user-tone-button",
          role: "listbox",
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        {styles?.map((style) => (
          <MenuItem key={style.id} onClick={() => handleSelectStyle(style)}>
            <Stack direction="row" spacing={1} alignItems="center">
              {style.isDefault ? (
                <Star />
              ) : style.type === "Global" ? (
                <AccountBalanceIcon fontSize="small" />
              ) : (
                <PersonOutlineIcon fontSize="small" />
              )}

              <Typography variant="body2">{style.name}</Typography>
            </Stack>
          </MenuItem>
        ))}
        <MenuItem component={Link} to={`${environment.webAppUrl}/writing-styles`} target="_blank">
          <Stack direction="row" spacing={1} alignItems="center">
            <AddIcon fontSize="small" />
            <Typography variant="body2">Add or edit styles</Typography>
          </Stack>
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserStyles;
